// xMainProductBundle.fixed.js
// Rewritten full script for bundle product Alpine component
// - Fixes bug where quantity changes to 0 weren't detected because inactive items were skipped
// - Safer qty/variant parsing and prev-qty tracking
// - Optional debug flag
// - Robust SVG/shadow-dom click handling using composedPath()/path fallback
// - Keyboard support (Enter / Space) for subscription radio options
// - Injects minimal CSS for pointer on SVG radios

if (!window.Eurus) window.Eurus = {};
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = new Set();

if (!window.Eurus.loadedScript.has('main-product-bundle.fixed.js')) {
  window.Eurus.loadedScript.add('main-product-bundle.fixed.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xMainProductBundle', (
        sectionId,
        price,
        variantId,
        productTitle,
        shopCurrency
      ) => ({

        /* ---------- state ---------- */
        loading: false,
        disabled: true,
        cartItems: [],
        total_price: 0,
        container: null,
        addToCartButton: null,
        bundleProductData: { main_product: { selling_plan: false } },
        haveSubscription: false,
        mainProductPrice: price || 0,
        currentVariantId: variantId,
        activeSellingPlan: false,
        activeSellingname: false,

        // debugging toggle
        debug: false,

        pricingTable: {
          2: 31.0,
          3: 28.67,
          4: 27.5,
          5: 27.0,
          6: 26.67,
          7: 26.66,
          8: 26.63,
          9: 26.61,
          10: 27.6,
          11: 26.63,
        },

        getBundleTierTotalCents(totalQty) {
          if (!totalQty || totalQty <= 0) return 0;
          const tierQty = Math.min(Math.max(totalQty, 2), 11);
          const perUnit = this.pricingTable[tierQty];
          // console.log('[xMainProductBundle] getBundleTierTotalCents: totalQty:', totalQty, 'tierQty:', tierQty, 'perUnit:', perUnit);
          return perUnit ? Math.round(perUnit * totalQty * 100) : 0;
        },

        /* ---------- INIT ---------- */
        initBundle(el) {
          try {
            this.container = el;

            // Only add global listener once
            if (!this._variantListenerAdded) {
              document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
                if (this.debug) console.log('[xMainProductBundle] variant updated, re-initializing bundle UI');
                
                // Update price and data from the new HTML
                if (e.detail && e.detail.html) {
                  try {
                    // Manually sync the flavour bundle HTML and classes
                    const newWrapper = e.detail.html.querySelector(`.bundle-flavour-wrapper-${sectionId}`);
                    const oldWrapper = document.querySelector(`.bundle-flavour-wrapper-${sectionId}`);
                    if (newWrapper && oldWrapper) {
                      oldWrapper.innerHTML = newWrapper.innerHTML;
                      oldWrapper.className = newWrapper.className;
                    }

                    const dataEl = e.detail.html.querySelector('#bundle-flavor-product-data');
                    if (dataEl) {
                      this.bundleProductData = JSON.parse(dataEl.innerHTML);
                    }
                    
                    const variantEl = e.detail.html.querySelector('script[data-selected-variant]');
                    if (variantEl) {
                      const newVariant = JSON.parse(variantEl.textContent);
                      if (newVariant) {
                        this.mainProductPrice = newVariant.price;
                        this._originalMainPrice = Number(newVariant.price) || 0;
                        this.currentVariantId = newVariant.id;
                      }
                    }
                  } catch (err) {
                    if (this.debug) console.error('[xMainProductBundle] Error updating from new HTML', err);
                  }
                }

                requestAnimationFrame(() => {
                  this.initBundle(this.container);
                });
              });
              this._variantListenerAdded = true;
            }

            this.addToCartButton = el.querySelector('.js-add_to_cart_btn') || null;

            // inject small CSS for SVG/radio pointer
            try {
              if (!document.getElementById('xmainproduct-bundle-css')) {
                const s = document.createElement('style');
                s.id = 'xmainproduct-bundle-css';
                s.innerHTML = `\
                  .loop-widget-purchase-option-radio,\
                  .loop-widget-purchase-option-radio svg { cursor: pointer; pointer-events: auto; }\
                `;
                document.head.appendChild(s);
              }
            } catch (e) { /* ignore */ }

            // parse bundle data
            const dataEl = el.querySelector('#bundle-flavor-product-data');
            try {
              this.bundleProductData = dataEl ? JSON.parse(dataEl.innerHTML) : { main_product: { selling_plan: false } };
            } catch (e) {
              console.error('[xMainProductBundle] parse bundle-flavor-product-data error', e);
              this.bundleProductData = { main_product: { selling_plan: false } };
            }

            this.haveSubscription = !!(this.bundleProductData?.main_product?.selling_plan);
            // DO NOT override this.mainProductPrice here if it was already set by variant change logic
            if (typeof this._originalMainPrice === 'undefined') {
              this.mainProductPrice = price || 0;
              this._originalMainPrice = Number(price) || 0;
            }

            // wait for loop widget to be available if subscription exists
            if (this.haveSubscription) {
              let loopWidgetTimer = setInterval(() => {
                const loopElement = el.querySelector('.loop-widget-container [data-loop-widget-selling-plan-group]');
                if (loopElement) {
                  clearInterval(loopWidgetTimer);
                  try { this.loopWidget(); } catch (e) { console.error(e); }
                }
              }, 100);

              window.addEventListener('load', () => {
                    const faqWrapper = document.querySelector('.product-faq-wrapper'); 
          // If faqWrapper does NOT exist → DO NOTHING (skip removing href)
          const shouldModifyLinks = !!faqWrapper;  // true / false
          const targetDivs = document.querySelectorAll('.loop-widget-sp-selector-description');
          targetDivs.forEach(div => {
            const handleAnchor = (container) => {
              const anchors = container.querySelectorAll('a');
              anchors.forEach(a => {
                // ❗ href remove ONLY if faqWrapper exists
                if (shouldModifyLinks) {
                  a.removeAttribute('href');
                  a.style.cursor = 'pointer';
                }
                a.addEventListener('click', () => {
                  if (shouldModifyLinks) {
                    // scroll only if wrapper exists
                    faqWrapper.scrollIntoView({
                      behavior: 'smooth',
                      block: 'start'
                    });
                  } else {
                    console.log("faqWrapper not found → normal link behavior");
                  }

                });
              });
            };

            handleAnchor(div);

            const observer = new MutationObserver(mutations => {
              mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                  if (node.nodeType === 1) handleAnchor(node);
                });
              });
            });
            observer.observe(div, { childList: true, subtree: true });
          });
          const first = document.querySelector('.faq-collapsible');
          if (first) first.click();
                setTimeout(() => {
                  try { clearInterval(loopWidgetTimer); } catch (e) {}
                }, 10000);
              });
            }

            // flavour add-to-cart buttons: show qty UI
            this.container.querySelectorAll('.flavour-add-to-cart').forEach(btn => {
              btn.addEventListener('click', () => {
                if (btn.disabled) return;
                const parent = btn.closest('.flavour-icon-container');
                if (!parent || parent.dataset.variantAvailable === 'false') return;
                const qtyWrapper = parent.querySelector('.bundle-qty-wrapper');
                const qtyInput = qtyWrapper ? qtyWrapper.querySelector('.qty-input') : null;

                if (qtyWrapper) {
                  btn.style.display = 'none';
                  qtyWrapper.style.display = 'flex';
                  if (qtyInput && parseInt(qtyInput.value) === 0) qtyInput.value = 1;
                  const icon = parent.querySelector('.flavour-icon-item');
                  if (icon) icon.classList.add('is-active');
                  this.updateCartItem();
                  this.updateTotalPrice();
                }
              });
            });

            // quantity plus/minus handlers
            const qtyWrappers = this.container.querySelectorAll('.bundle-qty-wrapper');
            qtyWrappers.forEach(wrapper => {
              const input = wrapper.querySelector('.qty-input');
              const plus = wrapper.querySelector('.plus');
              const minus = wrapper.querySelector('.minus');
              const parent = wrapper.closest('.flavour-icon-container');
              const addBtn = parent ? parent.querySelector('.flavour-add-to-cart') : null;

              if (plus) {
                plus.addEventListener('click', () => {
                  if (parent && parent.dataset.variantAvailable === 'false') return;
                  let current = parseInt(input.value) || 0;
                  current += 1;
                  input.value = current;
                  if (parent) {
                    const icon = parent.querySelector('.flavour-icon-item');
                    if (icon) icon.classList.add('is-active');
                  }
                  this.updateCartItem();
                  this.updateTotalPrice();
                });
              }

              if (minus) {
                minus.addEventListener('click', () => {
                  let current = parseInt(input.value) || 0;
                  if (current > 1) {
                    current -= 1;
                    input.value = current;
                  } else {
                    current = 0;
                    input.value = 0;
                    wrapper.style.display = 'none';
                    if (addBtn) addBtn.style.display = 'inline-block';
                    if (parent) {
                      const icon = parent.querySelector('.flavour-icon-item');
                      if (icon) icon.classList.remove('is-active');
                    }
                  }
                  this.updateCartItem();
                  this.updateTotalPrice();
                });
              }
            });

            // initial render
            this.updateCartItem();
            this.updateTotalPrice();
          } catch (e) {
            console.error('[xMainProductBundle] initBundle error', e);
          }
        },

        /* ---------- Purchase Options Label Helper ---------- */
        updatePurchaseOptionLabel(selectedLabelEl, selectedOption, loopWidget) {
          try {
            if (!loopWidget) return;
            let wrapper = loopWidget.querySelector('.loop-widget-purchase-options-label');

            if (wrapper && !wrapper.querySelector('.purchase-option-label')) {
              const originalText = wrapper.textContent.trim();
              wrapper.innerHTML = '';

              const purchaseLabel = document.createElement('span');
              purchaseLabel.className = 'purchase-option-label';
              purchaseLabel.innerText = originalText ? (originalText + ' : ') : 'Purchase Options : ';
              wrapper.appendChild(purchaseLabel);

              const planNameLabel = document.createElement('span');
              planNameLabel.className = 'selected-plan-name-label';
              wrapper.appendChild(planNameLabel);
            }

            if (!wrapper) {
              wrapper = document.createElement('div');
              wrapper.className = 'loop-widget-purchase-options-label';

              const purchaseLabel = document.createElement('span');
              purchaseLabel.className = 'purchase-option-label';
              purchaseLabel.innerText = 'Purchase Options : ';
              wrapper.appendChild(purchaseLabel);

              const planNameLabel = document.createElement('span');
              planNameLabel.className = 'selected-plan-name-label';
              planNameLabel.innerText = '';
              wrapper.appendChild(planNameLabel);

              const target = loopWidget.querySelector('[data-loop-widget-selling-plan-group]') || loopWidget;
              target.appendChild(wrapper);
            }

            const planLabel = wrapper.querySelector('.selected-plan-name-label');

            const planText = (selectedLabelEl && selectedLabelEl.innerText)
              ? selectedLabelEl.innerText.trim()
              : (selectedOption?.innerText?.trim() || '');

            if (!planText && selectedOption && typeof selectedOption === 'object' && selectedOption.innerText) {
              if (planLabel) planLabel.innerText = selectedOption.innerText;
            } else {
              if (planLabel) planLabel.innerText = planText;
            }

            if (planLabel && planLabel.innerText) {
              wrapper.classList.remove('hidden');
            } else {
              wrapper.classList.add('hidden');
            }

          } catch (e) {
            console.error('[xMainProductBundle] updatePurchaseOptionLabel error', e);
          }
        },

        /* ---------- Helper: Find plan data by ID or Name ---------- */
        findPlanData(planData, id, name, fallbackToAny = false) {
          if (!planData || typeof planData !== 'object') return null;
          
          let plan = null;
          // 1. Try matching by ID as a direct key
          if (id && planData[id]) {
            plan = planData[id];
          } 
          // 2. Try iterates to match by ID property
          else if (id) {
            const idNum = Number(id);
            for (const k in planData) {
              if (Number(planData[k].id) === idNum) {
                plan = planData[k];
                break;
              }
            }
          }

          // 3. Try matching by name if no ID match
          if (!plan && name) {
            for (const k in planData) {
              const p = planData[k];
              if (p.name === name || k === name) {
                plan = p;
                break;
              }
              if (name.includes(p.name || k) || (p.name || k).includes(name)) {
                plan = p;
                break;
              }
            }
          }

          // 4. Fallback to first available plan if requested
          if (!plan && fallbackToAny) {
            const all = Object.values(planData);
            if (all.length > 0 && typeof all[0] === 'object') plan = all[0];
          }

          return plan;
        },

        /* ---------- Cart Items Rebuild (FIXED) ---------- */
        updateCartItem() {
          try {
            // ensure prev map exists
            this._prevQuantities = this._prevQuantities || {};
            this.cartItems = [];

            const flavourContainers = this.container.querySelectorAll('.flavour-icon-container');
            flavourContainers.forEach(ele => {
              // read identifiers / qty first (do NOT early-return)
              const qtyInput = ele.querySelector('.qty-input');
              const rawQty = qtyInput ? qtyInput.value : null;
              const variantUnavailable = (ele.getAttribute('data-variant-available') || '') === 'false';
              let qty = rawQty !== null ? (parseInt(rawQty) || 0) : 0;
              if (variantUnavailable) {
                if (qty > 0 && qtyInput) qtyInput.value = 0;
                qty = 0;
                const wrap = ele.querySelector('.bundle-qty-wrapper');
                const addBtn = ele.querySelector('.flavour-add-to-cart');
                if (wrap) wrap.style.display = 'none';
                if (addBtn) addBtn.style.display = '';
              }
              const productId = ele.dataset.productId || null; // keep as string key to match bundleProductData
              const variantIdRaw = ele.dataset.variantId || ele.dataset.variant || null;
              const variantIdNum = variantIdRaw ? Number(variantIdRaw) : null;
              const productTitle = ele.dataset.productTitle || '';
              const icon = ele.querySelector('.flavour-icon-item');

              // previous qty for change detection
              const prevQty = Number(this._prevQuantities[String(variantIdRaw)] || 0);

              // Determine unit price and selling plan id
              let unitPrice = Number(ele.dataset.price) || 0;
              let selling_plan_id = false;
              const productData = productId ? (this.bundleProductData?.[productId]) : null;

              if (productData && productData.onetime_price) {
                unitPrice = Number(productData.onetime_price) || unitPrice;
              }

              let isSubscriptionActive = false;
              const loopWidget = this.container?.querySelector('.loop-widget-container') || document.querySelector('.loop-widget-container');
              if (loopWidget) {
                const loopSubscription = loopWidget.querySelector('[data-loop-widget-selling-plan-group]');
                const subRadio = loopWidget.querySelector('input[name="loop-purchase-options"][value="subscription"]:checked') 
                                || loopWidget.querySelector('input[data-loop-widget-selling-plan-group-radio]:checked');
                
                if (subRadio || (loopSubscription && loopSubscription.classList.contains('loop-widget-purchase-option-selected'))) {
                  isSubscriptionActive = true;
                }
              }

              if (isSubscriptionActive && productData && productData.selling_plan) {
                const sellSelect = this.container.querySelector('select[name="selling_plan"]') || document.querySelector('select[name="selling_plan"]');
                const selectedPlanId = sellSelect ? Number(sellSelect.value) : (this.activeSellingPlan || null);
                const selectedPlanName = sellSelect?.selectedOptions?.[0]?.innerText?.trim() || this.activeSellingname || null;

                const planObj = this.findPlanData(productData.selling_plan, selectedPlanId, selectedPlanName, true);
                if (planObj) {
                  unitPrice = Number(planObj.price) || unitPrice;
                  selling_plan_id = planObj.id || selling_plan_id;
                }
              }

              // push to cartItems if qty >=1
              if (qty >= 1) {
                this.cartItems.push({
                  id: variantIdNum || Number(ele.dataset.variantId) || 0,
                  quantity: qty,
                  title: productTitle,
                  price: unitPrice,
                  selling_plan_id
                });

                // ensure visual active state
                if (icon) icon.classList.add('is-active');
              } else {
                // ensure visual inactive state when qty is zero
                if (icon) icon.classList.remove('is-active');
              }

              // --- detect change for THIS variant only ---
              if (prevQty !== qty) {
                if (this.debug) console.log('[xMainProductBundle] qty changed for variant', variantIdRaw, 'from', prevQty, 'to', qty);

                // Log productData and onetime/unit price details (debug only)
                if (this.debug) {
                  console.log('productData:', productData);
                  console.log('onetimePrice (unit):', Number(ele.dataset.price) || 0);
                }

                // find selected plan (data-selected or native) and its object for this product
                const sellSelect = this.container.querySelector('select[name="selling_plan"]') || document.querySelector('select[name="selling_plan"]');
                let selectedOption = null;
                if (sellSelect) {
                  selectedOption = sellSelect.querySelector('option[data-selected="true"]') || sellSelect.selectedOptions?.[0] || null;
                }
                const selectedPlanName = selectedOption ? selectedOption.innerText.trim() : null;
                const selectedPlanId = selectedOption ? selectedOption.value : null;
                if (this.debug) console.log('[xMainProductBundle] selectedPlanName:', selectedPlanName, 'selectedPlanId:', selectedPlanId);

                if (selectedPlanName && productData && productData.selling_plan && productData.selling_plan[selectedPlanName]) {
                  const planObj = productData.selling_plan[selectedPlanName];
                  if (this.debug) console.log('[xMainProductBundle] plan object for changed variant:', planObj);
                  // update loop widget DOM price elements (one-time and subscription) for changed product
                  try {
                    const oneTimePriceSelector = '[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price-container .loop-widget-purchase-option-price';
                    const subPriceSelector = '[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price-container .loop-widget-purchase-option-price';
                    const oneTimeEl = document.querySelector(oneTimePriceSelector);
                    const subEl = document.querySelector(subPriceSelector);

                    // onetime display: use element's dataset price (onetime unit) — format with shopCurrency
                    if (oneTimeEl) {
                      oneTimeEl.textContent = this.formatMoney(Number(ele.dataset.price) || 0, shopCurrency);
                    }
                    // subscription display: show plan price for this product
                    if (subEl) {
                      subEl.textContent = this.formatMoney(planObj.price || 0, shopCurrency);
                    }
                  } catch (e) {
                    console.error('[xMainProductBundle] update widget price DOM error for changed variant', e);
                  }
                } else {
                  // if no plan object found, still update one-time DOM price for this changed variant
                  try {
                    const oneTimeEl = document.querySelector('[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price');
                    if (oneTimeEl) oneTimeEl.textContent = this.formatMoney(Number(ele.dataset.price) || 0, shopCurrency);
                  } catch (e) {}
                }
              }

              // finally update prev map for this variant (always set, even if inactive)
              this._prevQuantities[String(variantIdRaw)] = qty;
            });

            // enable/disable addToCartButton as before
            const qtysum = this.cartItems.reduce((acc, ele) => acc + Number(ele.quantity || 0), 0);
            if (this.addToCartButton) {
              const minExtrasToEnable = 2;
              this.addToCartButton.disabled = (qtysum < minExtrasToEnable);

              if (qtysum === 0) {
                const container = this.container || document;

                // try find local loopWidget first
                const loopWidget = container.querySelector('.loop-widget-container') || document.querySelector('.loop-widget-container');

                const oneTimePriceSelectorCandidates = [
                  '[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price-container .loop-widget-purchase-option-price',
                  '[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price',
                  '.loop-widget-onetime .loop-widget-purchase-option-price'
                ];
                const subPriceSelectorCandidates = [
                  '[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price-container .loop-widget-purchase-option-price',
                  '[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price',
                  '.loop-widget-subscription .loop-widget-purchase-option-price'
                ];

                const findEl = (candidates, scope) => {
                  for (let sel of candidates) {
                    const el = (scope || container).querySelector(sel);
                    if (el) return el;
                  }
                  // fallback to global document
                  for (let sel of candidates) {
                    const el = document.querySelector(sel);
                    if (el) return el;
                  }
                  return null;
                };

                const oneTimeEl = findEl(oneTimePriceSelectorCandidates, loopWidget || container);
                const subEl = findEl(subPriceSelectorCandidates, loopWidget || container);

                if (oneTimeEl) {
                  oneTimeEl.textContent = this.formatMoney(Number(this._originalMainPrice) || 0, shopCurrency);
                }

                let subscriptionDisplayAmount = Number(this._originalMainPrice) || 0;
                try {
                  const sellSelect = (loopWidget && loopWidget.querySelector('select[name="selling_plan"]')) 
                                      || container.querySelector('select[name="selling_plan"]') 
                                      || document.querySelector('select[name="selling_plan"]');
                  if (sellSelect) {
                    const selectedOption = sellSelect.querySelector('option[data-selected="true"]') || sellSelect.selectedOptions?.[0] || null;
                    if (selectedOption) {
                      const planName = selectedOption.innerText?.trim();
                      if (planName && this.bundleProductData?.main_product?.selling_plan?.[planName]) {
                        const planObj = this.bundleProductData.main_product.selling_plan[planName];
                        subscriptionDisplayAmount = Number(planObj.price) || subscriptionDisplayAmount;
                      } else if (selectedOption.dataset && selectedOption.dataset.price) {
                        subscriptionDisplayAmount = Number(selectedOption.dataset.price) || subscriptionDisplayAmount;
                      }
                    }
                  }
                } catch (e) { /* fallback to original */ }

                if (subEl) {
                  subEl.textContent = this.formatMoney(subscriptionDisplayAmount, shopCurrency);
                }
              }

            }

          } catch (e) {
            console.error('[xMainProductBundle] updateCartItem error', e);
          }
        },

        /* ---------- Total Price ---------- */
        updateTotalPrice() {
          try {
            let sum = 0;
            this.cartItems.forEach(item => {
              const price = Number(item.price) || 0;
              const qty = Number(item.quantity) || 0;
              sum += price * qty;
            });
            this.total_price = sum;

            const mainPrice = Number(this.mainProductPrice) || 0;
            const totalQty = this.cartItems.reduce((acc, item) => acc + Number(item.quantity || 0), 0);
            let tierFinalAmount = null;
            let compareAmount = null;
            let subTierAmount = null;
            const mainPriceArea = this.container.querySelector(`#price-${sectionId}`);

            if (totalQty > 0) {
              tierFinalAmount = this.getBundleTierTotalCents(totalQty);
              compareAmount = mainPrice + sum;
              this.total_price = tierFinalAmount;
              subTierAmount = Math.round(tierFinalAmount * 0.9);

              if (mainPriceArea) {
                mainPriceArea.querySelectorAll('.js-bundle-price').forEach(el => {
                  el.innerHTML = this.formatMoney(tierFinalAmount, shopCurrency);
                });

                const compareEl = mainPriceArea.querySelector('.price-compare');
                if (compareEl) {
                  compareEl.textContent = this.formatMoney(compareAmount, shopCurrency);
                }
              }
            } else {
              const amount = mainPrice + this.total_price;

              this.container.querySelectorAll('.js-bundle-price, .js-product-price').forEach(element => {
                element.innerHTML = this.formatMoney(amount, shopCurrency);
              });
            }

            // console.log('[xMainProductBundle] total price updated:', this.total_price, 'compareAmount:', compareAmount, 'tierFinalAmount:', tierFinalAmount, 'subTierAmount:', subTierAmount);
            // --- Update loop widget purchase option prices ---
            try {
              const loopWidget =
                this.container?.querySelector('.loop-widget-container') ||
                document.querySelector('.loop-widget-container');

              if (loopWidget) {
                const subOptionEl     = loopWidget.querySelector('.loop-widget-purchase-option-subscription') || loopWidget.querySelector('[data-loop-widget-selling-plan-group]');
                const oneTimeOptionEl = loopWidget.querySelector('.loop-widget-purchase-option-onetime')     || loopWidget.querySelector('[data-loop-widget-onetime-purchase-option]');

                const isSubSelected = subOptionEl && subOptionEl.classList.contains('loop-widget-purchase-option-selected');
                if (isSubSelected) {
                  if (mainPriceArea) {
                    mainPriceArea.querySelectorAll('.js-bundle-price').forEach(el => {
                      el.innerHTML = this.formatMoney(subTierAmount, shopCurrency);
                    });
                  }
                }

                const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
                const format = this.shopCurrency || (window.Shopify && window.Shopify.money_format) || shopCurrency || '${{amount}}';

                if (tierFinalAmount !== null) {

                  const oneTimePriceEls = loopWidget.querySelectorAll(
                    '.loop-widget-purchase-option-onetime .loop-widget-purchase-option-price, [data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price'
                  );
                  oneTimePriceEls.forEach(el => {
                    el.textContent = this.formatMoney(tierFinalAmount, format);
                  });

                  const subPriceEls = loopWidget.querySelectorAll(
                    '.loop-widget-purchase-option-subscription .loop-widget-purchase-option-price, [data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price'
                  );
                  subPriceEls.forEach(el => {
                    el.textContent = this.formatMoney(subTierAmount, format);
                  });
                } else {
                const subPriceEls = loopWidget.querySelectorAll('.loop-widget-purchase-option-subscription .loop-widget-purchase-option-price, [data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price');
                
                if (subPriceEls.length > 0) {
                  const sellSelect =
                    loopWidget.querySelector('select[name="selling_plan"]') ||
                    document.querySelector('select[name="selling_plan"]');
                  
                  const selectedPlanId = sellSelect ? Number(sellSelect.value) : (this.activeSellingPlan || null);
                  const selectedPlanName = sellSelect?.selectedOptions?.[0]?.innerText?.trim() || this.activeSellingname || null;

                  // Main product subscription price
                  const mainPlanObj = this.findPlanData(this.bundleProductData?.main_product?.selling_plan, selectedPlanId, selectedPlanName, true);
                  const subMainPrice = (mainPlanObj ? Number(mainPlanObj.price) : null) 
                                       || Number(this.mainProductPrice) || Number(this._originalMainPrice) || 0;

                  let subBundleSum = 0;
                  this.container.querySelectorAll('.flavour-icon-container').forEach(ele => {
                    const qtyInput = ele.querySelector('.qty-input');
                    const qty = qtyInput ? (parseInt(qtyInput.value) || 0) : 0;
                    if (qty > 0) {
                      const productId = ele.dataset.productId || null;
                      const productData = productId ? this.bundleProductData?.[productId] : null;
                      
                      if (productData && productData.selling_plan) {
                        const itemPlanObj = this.findPlanData(productData.selling_plan, selectedPlanId, selectedPlanName, true);
                        const itemSubPrice = (itemPlanObj ? Number(itemPlanObj.price) : null)
                                            || Number(productData.onetime_price) || Number(ele.dataset.price) || 0;
                        subBundleSum += itemSubPrice * qty;
                      } else if (productData) {
                        subBundleSum += (Number(productData.onetime_price) || Number(ele.dataset.price) || 0) * qty;
                      }
                    }
                  });

                  const totalSubAmount = subMainPrice + subBundleSum;
                  subPriceEls.forEach(el => {
                    el.textContent = this.formatMoney(totalSubAmount, format);
                  });
                }

                // ── One-time price projection ──
                const oneTimePriceEls = loopWidget.querySelectorAll('.loop-widget-purchase-option-onetime .loop-widget-purchase-option-price, [data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price');
                if (oneTimePriceEls.length > 0) {
                  const oneTimeMainPrice = Number(this._originalMainPrice) || mainPrice;
                  let oneTimeBundleSum = 0;
                  this.container.querySelectorAll('.flavour-icon-container').forEach(ele => {
                    const qtyInput = ele.querySelector('.qty-input');
                    const qty = qtyInput ? (parseInt(qtyInput.value) || 0) : 0;
                    if (qty > 0) {
                      const productId = ele.dataset.productId || null;
                      const productData = productId ? this.bundleProductData?.[productId] : null;
                      const oneTimePrice = (productData && productData.onetime_price)
                        ? Number(productData.onetime_price)
                        : (Number(ele.dataset.price) || 0);
                      oneTimeBundleSum += oneTimePrice * qty;
                    }
                  });

                  const totalOneTimeAmount = oneTimeMainPrice + oneTimeBundleSum;
                  oneTimePriceEls.forEach(el => {
                    el.textContent = this.formatMoney(totalOneTimeAmount, format);
                  });
                }
                }
              }
            } catch (priceUpdateErr) {
              console.error('[xMainProductBundle] loop widget price update error', priceUpdateErr);
            }

            // ── Target Price Implementation (Mirrors main-product-subscription.js) ──
            try {
              const oneTimeprice = document.querySelector("[id^='loop-widget-purchase-option-price-onetime-']");
              const bundlePriceBox = document.querySelector('.bundle-subscribition-price');

              if (bundlePriceBox && oneTimeprice) {
                  let smallTag = bundlePriceBox.querySelector('small.cap');
                  let spanDashed = bundlePriceBox.querySelector('.price-dashed');

                  // If elements don't exist, create them dynamically
                  if (!smallTag) {
                      smallTag = document.createElement('small');
                      smallTag.className = 'cap rtl:inline-block';
                      
                      const sTag = document.createElement('s');
                      sTag.className = 'price-compare rtl:leading-tight';
                      smallTag.appendChild(sTag);
                      
                      bundlePriceBox.prepend(smallTag);
                  }

                  if (!spanDashed) {
                      spanDashed = document.createElement('span');
                      spanDashed.className = 'price-dashed';
                      spanDashed.innerText = '- ';
                      
                      smallTag.after(spanDashed);
                  }

                  // Update content — use catalog compare when tier pricing is active
                  const sTag = smallTag.querySelector('s.price-compare');
                  if (sTag) {
                      if (compareAmount !== null) {
                        sTag.textContent = this.formatMoney(compareAmount, shopCurrency);
                      } else if (oneTimeprice) {
                        sTag.textContent = oneTimeprice.textContent.trim();
                      }
                  }
              }

              // Visibility toggle based on one-time selected
              const loopSubscriptionType = document.querySelector('.loop-widget-container');
              const loopTyepeCheck = loopSubscriptionType ? loopSubscriptionType.querySelector('[data-loop-widget-onetime-purchase-option]') : null;
              
              if (bundlePriceBox) {
                  const priceCompare = bundlePriceBox.querySelector('.price-compare');
                  const priceDashed = bundlePriceBox.querySelector('.price-dashed')
                  if (loopTyepeCheck && loopTyepeCheck.classList.contains('loop-widget-purchase-option-selected')) {
                       priceCompare?.classList.add('hidden');
                       priceDashed?.classList.add('hidden');
                 } else {
                      priceCompare?.classList.remove('hidden');
                      priceDashed?.classList.remove('hidden');
                 }
              }
            } catch(e) {
               console.error('[xMainProductBundle] target price implementation error', e);
            }

            if (tierFinalAmount !== null) {
              const loopWidget =
                this.container?.querySelector('.loop-widget-container') ||
                document.querySelector('.loop-widget-container');
              const subOptionEl = loopWidget?.querySelector('[data-loop-widget-selling-plan-group]');
              const isSubSelected = subOptionEl && subOptionEl.classList.contains('loop-widget-purchase-option-selected');
              const atcAmount = isSubSelected
                ? Math.round(tierFinalAmount * 0.9)
                : tierFinalAmount;
              this.updateAddToCartButtonPrice(atcAmount, shopCurrency);
            }

          } catch (e) {
            console.error('[xMainProductBundle] updateTotalPrice error', e);
          }
        },

        updateAddToCartButtonPrice(amountCents, formatString) {
          const formatted = this.formatMoney(amountCents, formatString || shopCurrency);
          const btn = this.addToCartButton || this.container?.querySelector('.js-add_to_cart_btn');
          if (!btn) return;
          btn.querySelectorAll('.js-bundle-price, .js-product-price').forEach(el => {
            el.innerHTML = formatted;
          });
        },

        /* ---------- Formatting Helpers ---------- */
        formatWithDelimiters(number, precision, thousands, decimal) {
          precision = this.defaultOption(precision, 2);
          thousands = this.defaultOption(thousands, ',');
          decimal = this.defaultOption(decimal, '.');

          if (isNaN(number) || number == null) { return '0'; }
          number = (number / 100.0).toFixed(precision);

          var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

          return dollars + cents;
        },

        defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
        },

        formatMoney(amount, formatString) {
          try {
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var match = (formatString || '{{ amount }}').match(placeholderRegex);
            var key = match ? match[1] : 'amount';
            var value = '';
            switch (key) {
              case 'amount':
                value = this.formatWithDelimiters(amount, 2);
                break;
              case 'amount_no_decimals':
                value = this.formatWithDelimiters(amount, 0);
                break;
              case 'amount_with_comma_separator':
                value = this.formatWithDelimiters(amount, 2, '.', ',');
                break;
              case 'amount_no_decimals_with_comma_separator':
                value = this.formatWithDelimiters(amount, 0, '.', ',');
                break;
              default:
                value = (amount / 100).toFixed(2);
            }
            return String(formatString || '{{ amount }}').replace(placeholderRegex, value);
          } catch (e) {
            console.error('[xMainProductBundle] formatMoney error', e);
            return (amount / 100).toFixed(2);
          }
        },

        /* ---------- Add Bundle to Cart (unchanged) ---------- */
        bundleAddToCart(event) {
          try {
            this.loading = true;

            const bundleId = 'bundle_' + Date.now();
            const mainProductProperties = {};
            let productIndex = 1;
            const mainProductVariantId = this.currentVariantId;
            const mainProductTitle = productTitle;

            this.cartItems.forEach(item => {
              if (item.quantity > 0) {
                mainProductProperties[`product_${productIndex}`] = `${item.title} (${item.quantity})`;
                productIndex++;
              }
            });
            mainProductProperties['_bundle_id'] = bundleId;

            const mainProduct = {
              id: mainProductVariantId,
              quantity: 1,
              properties: mainProductProperties
            };
            
            let isOneTimeSelected = false;
            const loopOneTimeBtn = document.querySelector('[data-loop-widget-onetime-purchase-option]');
            if (loopOneTimeBtn && loopOneTimeBtn.classList.contains('loop-widget-purchase-option-selected')) {
              isOneTimeSelected = true;
            }

            if (!isOneTimeSelected && this.activeSellingPlan) {
              mainProduct.selling_plan = this.activeSellingPlan;
            }

            let childProductIndex = 1;
            const items = [
              ...this.cartItems.map(item => {
                const tmp = { id: item.id, quantity: item.quantity };
                if (!isOneTimeSelected && item.selling_plan_id) tmp.selling_plan = item.selling_plan_id;
                const childProperties = { '_main_bundle_id': bundleId };
                if (item.quantity > 0) {
                  childProperties._bundle_product_index = String(childProductIndex);
                  childProperties._bundle_product_title = item.title;
                  childProductIndex++;
                }
                tmp.properties = childProperties;
                return tmp;
              }),
              mainProduct
            ];

            const sections = (Alpine.store && Alpine.store('xCartHelper'))
              ? Alpine.store('xCartHelper').getSectionsToRender().map(s => s.id)
              : [];

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items, sections })
            })
            .then(res => res.json())
            .then(parsed => {
              try { if (this.addToCartButton) this.addToCartButton.removeAttribute('disabled'); } catch (e) {}

              if (parsed && (parsed.status == 422 || parsed.status == '422')) {
                try {
                  const error_message = (event && event.target)
                    ? event.target.closest('.bundler-sticky')?.querySelector('.cart-warning')
                    : this.container?.querySelector('.cart-warning');
                  this.errorMessage = true;
                  if (error_message) error_message.textContent = parsed.description || parsed.message || 'Cannot add items to cart';
                } catch (e) { }
                return;
              }

              document.dispatchEvent(new CustomEvent(`eurus:product-bundle:products-changed-${sectionId}`, {
                detail: { productsBundle: items, el: (event && event.target) ? event.target.closest(".product-bundler-wrapper") : (this.container || null) }
              }));

              try {
                const sectionArray = (Alpine.store && Alpine.store('xCartHelper'))
                  ? Alpine.store('xCartHelper').getSectionsToRender()
                  : [];

                sectionArray.forEach(section => {
                  section.selector.split(',').forEach(selector => {
                    const sectionElement = document.querySelector(selector);
                    if (sectionElement && parsed.sections && parsed.sections[section.id]) {
                      sectionElement.innerHTML = getSectionInnerHTML(parsed.sections[section.id], selector);
                    }
                  });
                });
              } catch (e) {
                console.error('[xMainProductBundle] section replace error', e);
              }

              try { if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) Alpine.store('xQuickView').show = false; } catch (e) {}
              try { Alpine.store('xPopup').close(); } catch (e) {}

              try {
                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(parsed);
                } else {
                  try {
                    if (window.Alpine && Alpine.store && Alpine.store('xMiniCart') && typeof Alpine.store('xMiniCart').openCart === 'function') {
                      Alpine.store('xMiniCart').openCart();
                    } else {
                      const cartBtn = document.querySelector('[data-cart-open], #CartDrawerToggle, #CartToggle, .cart-toggle, .js-cart-toggle, #CartIcon, .icon-cart');
                      if (cartBtn) cartBtn.click();
                      else {
                        const drawer = document.querySelector('#CartDrawer, .cart-drawer, .mini-cart');
                        if (drawer) drawer.classList.add('open', 'is-open', 'active');
                      }
                    }
                  } catch (e) { console.error('[xMainProductBundle] openCart fallback error', e); }

                  document.dispatchEvent(new CustomEvent("eurus:cart:redirect"));
                }
              } catch (e) { console.error('[xMainProductBundle] cart notification error', e); }

              try {
                const itemCount = parsed && parsed.item_count ? parsed.item_count : (document.querySelector('#cart-icon-bubble span') ? parseInt(document.querySelector('#cart-icon-bubble span').innerText || '0') : 0);
                if (Alpine.store && Alpine.store('xCartHelper')) {
                  Alpine.store('xCartHelper').currentItemCount = Number(itemCount || 0);
                }
                document.dispatchEvent(new CustomEvent("eurus:cart:items-changed", { detail: { item_count: itemCount } }));
              } catch (e) {}
            })
            .catch(err => {
              console.error('[xMainProductBundle] add to cart fetch error', err);
            })
            .finally(() => {
              try { Alpine.store('xCartHelper').updateEstimateShippingFull(); } catch (e) {}
              this.loading = false;
              this.cartItems = [];
              this.total_price = 0;
              try { this.updateCartItem(); this.updateTotalPrice(); } catch (e) {}
            });

          } catch (e) {
            console.error('[xMainProductBundle] bundleAddToCart error', e);
            this.loading = false;
          }
        },

        /* ---------- Loop Widget (subscription handling) with robust SVG click support ---------- */
        loopWidget() {
          const loopWidget = this.container.querySelector('.loop-widget-container');
          if (!loopWidget) {
            console.warn('[xMainProductBundle] loopWidget container not found');
            return;
          }

          const loopOneTime = loopWidget.querySelector('[data-loop-widget-onetime-purchase-option]');
          const loopSubscription = loopWidget.querySelector('[data-loop-widget-selling-plan-group]');
          const sellSelect = loopSubscription ? loopSubscription.querySelector('[name="selling_plan"]') : null;

          // helpers for robust event path handling
          const getEventPath = (ev) => {
            if (!ev) return [];
            if (ev.composedPath) return ev.composedPath();
            if (ev.path) return ev.path;
            const arr = [];
            let node = ev.target;
            while (node) { arr.push(node); node = node.parentNode || (node.host || null); }
            return arr;
          };

          const findInPath = (path, predicate) => {
            if (!path || !path.length) return null;
            for (let i = 0; i < path.length; i++) {
              const node = path[i];
              if (!node) continue;
              try { if (predicate(node)) return node; } catch (e) { continue; }
            }
            return null;
          };

          const updateSubscriptionContent = () => {
            try {
              if (!loopSubscription || !loopSubscription.classList.contains('loop-widget-purchase-option-selected')) {
                if (loopOneTime && loopOneTime.classList.contains('loop-widget-purchase-option-selected')) {
                  this.mainProductPrice = price;
                  this.activeSellingPlan = false;
                  this.activeSellingname = false;
                  this.updatePurchaseOptionLabel(null, { innerText: 'One-time purchase' }, loopWidget);
                } else {
                  this.activeSellingPlan = false;
                  this.activeSellingname = false;
                  this.updatePurchaseOptionLabel(null, null, loopWidget);
                }
                this.updateCartItem();
                this.updateTotalPrice();
                return;
              }

              const selectedOption = sellSelect?.selectedOptions?.[0];
              if (!selectedOption) return;

              const selectedLabelEl = loopSubscription.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-label')
                || selectedOption.parentElement?.querySelector('.loop-widget-purchase-option-label')
                || loopSubscription.querySelector('.loop-widget-purchase-option-label');

              const activeSellingPlanId = Number(selectedOption.value) || false;
              const activeSellingPlanName = selectedOption.innerText.trim();
              
              const planObj = this.findPlanData(this.bundleProductData?.main_product?.selling_plan, activeSellingPlanId, activeSellingPlanName, true);

              this.activeSellingPlan = activeSellingPlanId;
              this.activeSellingname = activeSellingPlanName;

              if (planObj) {
                this.mainProductPrice = planObj.price;
              } else {
                this.mainProductPrice = price;
              }

              this.updatePurchaseOptionLabel(selectedLabelEl, selectedOption, loopWidget);
              this.updateCartItem();
              this.updateTotalPrice();
            } catch (e) {
              console.error('[xMainProductBundle] updateSubscriptionContent error', e);
            }
          };

          // robust click handling: use composedPath to detect clicks on SVG/circle/etc
          const onWidgetClick = (ev) => {
            const path = getEventPath(ev);

            const oneTimeNode = findInPath(path, n => n.getAttribute && n.hasAttribute('data-loop-widget-onetime-purchase-option'));
            if (oneTimeNode) {
              setTimeout(() => {
                if (oneTimeNode.classList.contains('loop-widget-purchase-option-selected')) {
                  this.mainProductPrice = price;
                  this.activeSellingPlan = false;
                  this.activeSellingname = false;
                  this.updatePurchaseOptionLabel(null, { innerText: 'One-time purchase' }, loopWidget);
                  this.updateCartItem();
                  this.updateTotalPrice();
                }
              }, 150);
              return;
            }

            const subNode = findInPath(path, n => n.getAttribute && n.hasAttribute('data-loop-widget-selling-plan-group'));
            if (subNode) {
              setTimeout(() => {
                if (subNode.classList.contains('loop-widget-purchase-option-selected')) {
                  updateSubscriptionContent();
                } else {
                  this.updatePurchaseOptionLabel(null, null, loopWidget);
                  this.updateCartItem();
                  this.updateTotalPrice();
                }
              }, 150);
            }
          };

          // keyboard support for accessibility: Enter/Space triggers the option click behavior
          const onWidgetKeydown = (ev) => {
            if (ev.key !== 'Enter' && ev.key !== ' ') return;
            const path = getEventPath(ev);
            const optionNode = findInPath(path, n => n.getAttribute && (n.hasAttribute('data-loop-widget-onetime-purchase-option') || n.hasAttribute('data-loop-widget-selling-plan-group')));
            if (optionNode) {
              try { optionNode.click(); } catch (e) {
                const ce = new MouseEvent('click', { bubbles: true, cancelable: true });
                optionNode.dispatchEvent(ce);
              }
              ev.preventDefault();
            }
          };

          // attach listeners
          loopWidget.addEventListener('click', onWidgetClick, { passive: true });
          loopWidget.addEventListener('keydown', onWidgetKeydown, { passive: false });

          if (sellSelect) {
            sellSelect.addEventListener('change', () => updateSubscriptionContent());
          }

          // initial run
          updateSubscriptionContent();
        }

      }));
    });
  });
}
